import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useGenerateMeetingLinkForPatient = ({
  consultationId,
}: {
  consultationId: string;
}) => {
  const handleErrors = useQueryErrorHandling();
  return useQuery({
    queryKey: ["generateMeetingLinkForPatient", consultationId],
    queryFn: () => {
      return api.get(`/appointments/generate-call-invite/${consultationId}`);
    },

    onError: (res: any) => {
      handleErrors(res, "query");
    },
  });
};
